import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
const NoVaccancy = () => {

  const navigate = useNavigate();
  
  const navigateToSuccess = () =>{
    navigate('/post-vaccancy');
  }

const {t} = useTranslation();
  return (
    <div className="flex-center h-100 " style={{}}>
      <div className="text-center">
        <img className="mt-5" src="./images/no-data.png" alt="" />

        <h4 className="mt-3 opps">{t('Opps')} !</h4>
        <p className="text mt-2">
        
          {t('No Data Found')} !
     
          </p>

        <button className="theme-btn mt-5 btn-block" onClick={() => navigateToSuccess()}>{t('Post  New Vacancy')}</button>
      </div>
    </div>
  );
};

export default NoVaccancy;
